module.exports = __webpack_public_path__ + "static/media/trackIcon.d738613e.svg";